module.exports = __webpack_public_path__ + "static/media/cb_ln.6775f4c5.png";